import { NavLink } from 'react-router-dom';
import { Archive, Crosshair, LogOut, Radio, ScrollText, Trash2 } from 'lucide-react';
import { cn } from '@/lib/cn';
import { useLogout, useSession } from '@/features/auth/session';

const LINKS = [
  { to: '/feed', label: 'Feed', icon: Radio },
  { to: '/digest', label: 'Digest', icon: ScrollText },
  { to: '/targets', label: 'Targets', icon: Crosshair },
  { to: '/deleted', label: 'Deleted', icon: Trash2 },
  { to: '/archive', label: 'Archive', icon: Archive },
] as const;

export function NavRail() {
  const session = useSession();
  const logout = useLogout();

  return (
    <nav className="flex w-16 shrink-0 flex-col items-center border-r border-line bg-panel/60">
      <div className="flex h-12 w-full items-center justify-center border-b border-line">
        <span className="font-mono text-[11px] font-semibold tracking-[0.1em] text-accent">BB</span>
      </div>

      <div className="flex flex-1 flex-col items-center gap-1 py-3">
        {LINKS.map(({ to, label, icon: Icon }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) =>
              cn(
                'group relative flex w-14 flex-col items-center gap-1 rounded-sharp py-2 transition-colors',
                isActive
                  ? 'bg-accent-dim text-accent'
                  : 'text-ink-faint hover:bg-raised hover:text-ink',
              )
            }
          >
            {({ isActive }) => (
              <>
                {isActive ? (
                  <span className="absolute left-0 top-1 h-[calc(100%-0.5rem)] w-px bg-accent" />
                ) : null}
                <Icon size={16} strokeWidth={1.75} />
                <span className="font-mono text-[9px] uppercase tracking-[0.12em]">{label}</span>
              </>
            )}
          </NavLink>
        ))}
      </div>

      <div className="flex w-full flex-col items-center gap-1 border-t border-line py-3">
        <span
          className="font-mono text-[9px] uppercase tracking-[0.1em] text-ink-faint"
          title={session.data?.email}
        >
          {session.data?.displayName.slice(0, 6) ?? '—'}
        </span>
        <button
          type="button"
          onClick={() => logout.mutate()}
          disabled={logout.isPending}
          title="Sign out"
          className="flex size-7 items-center justify-center rounded-sharp text-ink-faint transition-colors hover:bg-raised hover:text-alert"
        >
          <LogOut size={14} strokeWidth={1.75} />
        </button>
      </div>
    </nav>
  );
}
